import { useRouter } from 'next/router'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquareCheck } from '@fortawesome/free-solid-svg-icons'

export default function PageExample({ data }) {
  const router = useRouter()

  return (
    <div>
      <h2 className='text-xl mb-4 font-bold text-slate-700 lg:mb-5 lg:text-3xl'>
        <FontAwesomeIcon icon={faSquareCheck} className='mt-0.5 mr-3 text-blue-400' />
        사용 예시
      </h2>
      <div className='flex flex-col gap-5 text-center lg:flex-row lg:gap-10'>
        {router.pathname === '/about/vision'
          ? data?.map((item, index) => (
              <div className='w-full lg:w-1/2' key={index}>
                <p className='text-sm font-bold text-slate-500 lg:text-xl'>{item.example}</p>
                {item.image?.map((image, index) => (
                  <img src={image} key={index} />
                ))}
              </div>
            ))
          : data?.map((item, index) => (
              <div className='w-full' key={index}>
                <p className='text-sm font-bold text-slate-500 lg:text-xl'>{item.example}</p>
                {item.image?.map((image, index) => (
                  <img src={image} key={index} />
                ))}
              </div>
            ))}
      </div>
    </div>
  )
}
